// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Footer {
    padding: 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: var(--noir);
    font-size: 13px;
    line-height: 1.6em;
    position: relative;
    bottom: 0;
    left: 0;
    right: 0;
}

.Footer p {
    color: var(--gris);
}

#copyright {
    margin-left: 5rem;
}

.ElyLogo {
    width: 7rem;
    margin-right: 5rem;
}

@media screen and (max-width: 600px) {
    .Footer {
        justify-content: center;
        flex-direction: column;
    }

    p {
        margin-left: 0rem;
    }

    .ElyLogo {
        margin-right: 0rem;
    }
}

/* @media screen and (max-width: 800px) {
    .Footer {
        position: fixed;
    }
} */`, "",{"version":3,"sources":["webpack://./src/components/Footer/Footer.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,6BAA6B;IAC7B,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;AACZ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI;QACI,uBAAuB;QACvB,sBAAsB;IAC1B;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;IACtB;AACJ;;AAEA;;;;GAIG","sourcesContent":[".Footer {\n    padding: 30px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    background-color: var(--noir);\n    font-size: 13px;\n    line-height: 1.6em;\n    position: relative;\n    bottom: 0;\n    left: 0;\n    right: 0;\n}\n\n.Footer p {\n    color: var(--gris);\n}\n\n#copyright {\n    margin-left: 5rem;\n}\n\n.ElyLogo {\n    width: 7rem;\n    margin-right: 5rem;\n}\n\n@media screen and (max-width: 600px) {\n    .Footer {\n        justify-content: center;\n        flex-direction: column;\n    }\n\n    p {\n        margin-left: 0rem;\n    }\n\n    .ElyLogo {\n        margin-right: 0rem;\n    }\n}\n\n/* @media screen and (max-width: 800px) {\n    .Footer {\n        position: fixed;\n    }\n} */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
